export default "__VITE_ASSET__CHdayWKR__"